import React from 'react';

class ResizeObserverErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Check if this is a ResizeObserver error
    const errorMessage = String(error.message || '').toLowerCase();
    if (errorMessage.includes('resizeobserver') || 
        errorMessage.includes('loop limit exceeded') ||
        errorMessage.includes('undelivered notifications')) {
      // Don't update state for ResizeObserver errors, just suppress them
      return null;
    }
    
    // For other errors, update state to show fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Check if this is a ResizeObserver error
    const errorMessage = String(error.message || '').toLowerCase();
    if (errorMessage.includes('resizeobserver') || 
        errorMessage.includes('loop limit exceeded') ||
        errorMessage.includes('undelivered notifications')) {
      // Suppress ResizeObserver errors completely
      return;
    }
    
    // Log other errors normally
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI for non-ResizeObserver errors
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>Something went wrong.</h2>
          <button onClick={() => this.setState({ hasError: false })}>
            Try again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ResizeObserverErrorBoundary;
